import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";

const useCoverEditor = ({ initialCoverState }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [scale, setScale] = useState(1);
  const [posX, setPosX] = useState(50);
  const [posY, setPosY] = useState(50);
  const [isDragging, setIsDragging] = useState(false);

  const initializedForGroupId = useRef(null);

  useEffect(() => {
    if (initialCoverState?.groupId && initializedForGroupId.current !== initialCoverState.groupId) {
      setPreviewUrl(initialCoverState.previewUrl);
      setScale(initialCoverState.scale);
      setPosX(initialCoverState.posX);
      setPosY(initialCoverState.posY);
      
      initializedForGroupId.current = initialCoverState.groupId;
    }
  }, [initialCoverState]);

  const handleFileChange = (file) => {
    if (!file || !file.type.startsWith("image/")) {
      toast.error("Please select a valid image file");
      return;
    }
    setSelectedFile(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileChange(e.dataTransfer.files[0]);
    }
  };

  return {
    selectedFile,
    previewUrl,
    scale,
    setScale,
    posX,
    setPosX,
    posY,
    setPosY,
    isDragging,
    setIsDragging,
    handleFileChange,
    handleDrop,
  };
};

export default useCoverEditor;
